import { SET_DEVICE_TYPE_FILTER } from "../types";

export const setDeviceTypeFilter = (types) => ({
  type: SET_DEVICE_TYPE_FILTER,
  payload: types,
})